import ManageBuyerGroup from './ManageBuyerGroup.component';

export default ManageBuyerGroup;